export const CopySettingsTypes = {
    COPY_MANAGERS: "copyManagers",
    COPY_ASSIGNED_USERS: "copyAssignedUsers",
    COPY_PROJECT_DESCRIPTION: "copyProjectDescription",
    COPY_CUSTOMER_DESCRIPTION: "copyCustomerDescription",
    COPY_TASK_DESCRIPTION: "copyTaskDescription",
    COPY_TASK_STATUS: "copyTaskStatus",
    COPY_TASK_TYPE_OF_WORK: "copyTaskTypeOfWork",
    COPY_TASK_ESTIMATE: "copyTaskEstimate",
}



// WEBPACK FOOTER //
// ./web/js/panels/components/constants.js